import { Component, Input, OnInit } from "@angular/core"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { FacetingService } from "../../services/faceting.service"
import { MobileFilterModalComponent } from "../modals/mobile-filter-modal/mobile-filter-modal.component"
import { EduComponent } from "../../utils/eduComponent"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    selector: "app-mobile-search-top-section",
    templateUrl: "./mobile-search-top-section.component.html",
    styleUrls: ["./mobile-search-top-section.component.scss"],
    standalone: false,
})
export class MobileSearchTopSectionComponent extends EduComponent implements OnInit {
    public shouldDisplayAppliedFilters: boolean = false
    public appliedFiltersCount: number = 0

    @Input() public searchInfo?: SearchInfoModel

    public get _appliedFiltersCount() {
        return this.appliedFiltersCount
    }

    public set _appliedFiltersCount(value) {
        this.appliedFiltersCount = value
    }

    constructor(
        protected facetingService: FacetingService,
        protected ngbModal: NgbModal
    ) {
        super()
    }

    public ngOnInit(): void {
        this.addSub(
            this.facetingService.filtersChanged.subscribe((data) => {
                if (data) {
                    this.appliedFiltersCount = data.length

                    if (this.searchInfo) {
                        this.appliedFiltersCount += 1
                    }
                }
            })
        )
    }

    public toggleFiltersDisplay(): void {
        this.shouldDisplayAppliedFilters = !this.shouldDisplayAppliedFilters
    }

    public openMobileFilters(): void {
        const modalRef = this.ngbModal.open(MobileFilterModalComponent, {
            windowClass: "search-modal",
        })
        modalRef.componentInstance.searchInfo = this.searchInfo
    }
}
